module.exports = {"for-rent":[],"for-sale":[]}


//////////////////
// WEBPACK FOOTER
// ./src/data/listings.json
// module id = 79
// module chunks = 0